import Vehicle from './models/Vehicle';
import VehicleModel from './models/VehicleModel';
import VehicleManufacturer from './models/VehicleManufacturer';

const vehicleModule = {
	state() {
		return {			
			vehicles: null,
			vehicleModels: null,
			vehicleManufacturers: null
		}
	},
	actions: {
		loadVehiclesAsync(ctx: any) {
			return new Promise((resolve: Function) => 
				setTimeout(() => {
					const vehicles = [
						new Vehicle({ 
							id: 1, 
							date: new Date(), 							
							model: new VehicleModel({ id: 1, name: 'RIO X-Line', manufacturer: new VehicleManufacturer({ id: 1, name: 'KIA'}), }),
							vin: 'FMJ1234R43210UT',
							govermentalNumber: 'у302ух199'
						}),
						new Vehicle({ 
							id: 2, 
							date: new Date(), 
							model: new VehicleModel({ id: 2, name: 'FX 35', manufacturer: new VehicleManufacturer({ id: 2, name: 'Infiniti'})}),
							vin: 'INFX12345R04321UU',
							govermentalNumber: 'о999оо199'
						})
					];
					ctx.commit('addVehicles', vehicles);
					resolve();					
				}, 300));
		},

		addVehicleAsync(ctx: any, payload: Vehicle) {			
			return new Promise((resolve: Function) => 
				setTimeout(() => {
					ctx.commit('addVehicle', payload);					
					resolve(true);
				}, 300));
		},

		loadVehicleModelsAsync(ctx: any) {
			return new Promise((resolve: Function) => 
				setTimeout(() => {
					const vehicleModels = [
						new VehicleModel({ 
							id: 1, 
							date: new Date(), 
							name: 'RIO X-Line',
							manufacturer: { id: 1, name: 'KIA'},
						}),
						new VehicleModel({ 
							id: 2, 
							date: new Date(), 
							name: 'FX 35',
							manufacturer: { id: 2, name: 'Infiniti'},
						}),
						new VehicleModel({ 
							id: 3, 
							date: new Date(), 
							name: 'QX 70',
							manufacturer: { id: 2, name: 'Infiniti'},
						}),
					];
					ctx.commit('addVehicleModels', vehicleModels);
					resolve();
				}, 300));
		},
	},
	mutations: {		
		/**
		 * replaces state.vehicles with new array of @param payload
		 */
		addVehicles(state: any, payload: Array<Vehicle>) {
			state.vehicles = payload;
		},

		/**
		 * replaces state.vehicles with new array of @param payload
		 */
		addVehicle(state: any, payload: Vehicle) {
			if (!state.vehicles) {
				state.vehicles = [];
			}

			state.vehicles.push(payload);
		},

		/**
		 * replaces state.vehicleModels with new array of @param models
		 */
		addVehicleModels(state: any, models: Array<VehicleModel>) {
			state.vehicleModels = models;
		},
	},
	getters: {		
		vehicles(state: any): Array<Vehicle> {
			if (!state.vehicles) {
				return new Array<Vehicle>();
			}

			return state.vehicles;
		},
		
		vehicleModels(state: any): Array<VehicleModel> {
			if (!state.vehicleModels) {
				return new Array<VehicleModel>();
			}

			return state.vehicleModels;
		}
	}
};

export default vehicleModule;